import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { TextInput, Typography } from '@guildeducationinc/recess';
import { ClientHeader } from '@src/components/LoginForm/ClientHeader';
import { SIGN_UP } from '@src/graphql/queries/user';
import { useCurrentClient } from '@src/hooks/useCurrentClient';
import { isEmpty } from 'lodash';
import { MessageType, Messages, TrackableButton, trackEvent, useLocale, } from 'pe-core-frontend';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClientWelcomeWrapper } from '../ClientWelcomeWrapper';
import styles from '../LoginForm/LoginForm.module.scss';
import { LoginSignupTab } from '../LoginSignupTab';
export const SignUpForm = ({ directLoginConfig }) => {
    const { t } = useLocale();
    const navigate = useNavigate();
    const [fieldErrors, setFieldErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [messages, setMessages] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const { currentClient } = useCurrentClient();
    const [signUp] = useMutation(SIGN_UP);
    const validate = () => {
        const fieldErrors = {};
        if (!email) {
            fieldErrors.email = t('Email is required');
        }
        setFieldErrors(fieldErrors);
        return isEmpty(fieldErrors);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessages([]);
        if (!validate())
            return;
        try {
            setSubmitting(true);
            const result = await signUp({
                variables: {
                    email,
                },
            });
            if (result.errors) {
                setMessages([{ type: MessageType.ERROR, value: result.errors[0].message }]);
                return;
            }
            const { success, message } = result.data.signUp;
            if (!success) {
                setMessages([{ type: MessageType.ERROR, value: message }]);
            }
            else {
                trackEvent('SignUpCompleted');
                setSubmitted(true);
                navigate('/auth/set-password', { state: { email } });
            }
        }
        catch (e) {
            setMessages([{ type: MessageType.ERROR, value: 'Error with sign up' }]);
        }
        finally {
            setSubmitting(false);
        }
    };
    if (!directLoginConfig)
        return null;
    return (_jsx("div", { className: styles.loginForm, children: _jsxs("div", { className: styles.container, children: [_jsx(ClientHeader, {}), _jsx(ClientWelcomeWrapper, { children: _jsx("fieldset", { disabled: submitting, children: _jsxs("form", { className: styles.form, onSubmit: handleSubmit, children: [_jsx(LoginSignupTab, { selectedTab: 'signup' }), _jsx(Typography, { variant: 'h1', children: t('Welcome {clientName} employees!', {
                                        values: { clientName: currentClient?.name },
                                    }) }), _jsx(Messages, { messages: messages }), !submitted && (_jsx(_Fragment, { children: _jsx(TextInput, { label: `${t('Account email')}`, helpText: t('Sign up description'), required: true, value: email, onChange: e => setEmail(e.target.value), errors: fieldErrors.email, "data-testid": 'emailInput' }) })), !submitted && (_jsxs("div", { className: styles.actions, children: [_jsx(TrackableButton, { enText: 'Sign up', tag: 'form', type: 'submit', "data-testid": 'signUpButton', children: t('Sign up') }, 'submit'), _jsxs("div", { className: 'flex flex-col flexItems--center mt-2', children: [_jsx(Typography, { variant: 'label2', children: t("By clicking sign up, you agree to Guild's") }), _jsxs("div", { children: [_jsx(TrackableButton, { btnType: 'link', enText: 'Terms', tag: 'footer', href: 'https://guild.com/terms-of-use', target: '_blank', rel: 'noopener noreferrer', children: t('Terms') }), "\u00A0", t('and'), "\u00A0", _jsx(TrackableButton, { btnType: 'link', enText: 'Privacy policy', tag: 'footer', href: 'https://guild.com/privacy-policy', target: '_blank', rel: 'noopener noreferrer', children: t('Privacy policy') })] })] })] }))] }) }) })] }) }));
};
